<template lang="pug">
yz-dialog(v-model="showDialog" persistent scrollable max-width="550px")
  yz-card
    yz-dialog-normal-header(title="Archive affected packages")
    yz-dialog-normal-content.px-6.py-6
      .d-flex.align-start
        v-icon.mr-2(color="danger" size="20") mdi-alert
        .yz-medium-body-sm.text-neutral-700 Changing the UOM conversion will affect the following packages. They will be archived before saving.
      .neutral200.rounded-lg.pa-3.mt-3(v-if="packages.length > 0")
        .yz-heading-10.text-neutral-700(v-for="(pkg, index) in packages" :key="pkg.id" :class="{ 'mt-1': index > 0 }") {{ pkg.product ? pkg.product.name : `Package #${pkg.id}` }}
      .yz-regular-body-sm.text-neutral-700.mt-3 Reselect the UOM for related products to reactivate these packages.
    yz-dialog-normal-actions
      .d-flex.align-center.gap-2
        yz-btn(size="lg" text label="Cancel" @click="onClose")
        yz-btn(size="lg" label="Archive and save" color="danger" :loading="loading" @click="onConfirm")
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    packages: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    onConfirm() {
      this.$emit('confirmed')
    },
    onClose() {
      this.$emit('closed')
      this.showDialog = false
    }
  }
}
</script>
